import { ActionIcon, Flex } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useTranslation } from "react-i18next";

import MobileNavigation from "../MobileNavigation/MobileNavigation";
import ProfileModal from "../ProfileModal/ProfileModal";
import SettingsMobileModal from "../Settings/SettingsMobileModal";

import { IconBell, IconList, IconSearch } from "@/components/icons";
import NotificationsModal from "@/components/widgets/NotificationMenu/components/NotificationsModal/NotificationsModal";
import BillingModal from "@/components/widgets/UserMenu/BillingModal";
import ContactModal from "@/components/widgets/UserMenu/ContactModal";

import type { FC } from "react";

interface HeaderMobileProps {
  open: () => void;
}

const HeaderMobile: FC<HeaderMobileProps> = ({ open }) => {
  const { t } = useTranslation();
  const [themeOpened, { open: showThemeModal, close: closeThemeModal }] = useDisclosure(false);
  const [supportOpened, { open: openSupport, close: closeSupport }] = useDisclosure(false);
  const [profileOpened, { open: openProfile, close: closeProfile }] = useDisclosure(false);
  const [billingOpened, { open: openBilling, close: closeBilling }] = useDisclosure(false);
  const [mobileNavigationOpened, { open: showMobileNavigation, close: closeMobileNavigation }] =
    useDisclosure(false);

  const [notificationsOpened, { open: openNotifications, close: closeNotifications }] =
    useDisclosure(false);

  return (
    <>
      {/* Header */}
      <Flex justify="center" gap="md">
        <ActionIcon onClick={open} aria-label={t("common.open_menu")}>
          <IconSearch fill="white" />
        </ActionIcon>

        <ActionIcon onClick={openNotifications} aria-label={t("common.open_menu")}>
          <IconBell fill="white" />
        </ActionIcon>

        <ActionIcon onClick={showMobileNavigation} aria-label={t("common.open_menu")}>
          <IconList fill="white" />
        </ActionIcon>
      </Flex>

      {/* Modal: Mobile Navigation */}
      <MobileNavigation
        opened={mobileNavigationOpened}
        close={closeMobileNavigation}
        openSupport={openSupport}
        showThemeModal={showThemeModal}
        openProfile={openProfile}
        openBilling={openBilling}
        openNotifications={openNotifications}
      />

      {/* Other Modals */}
      <ContactModal opened={supportOpened} onClose={closeSupport} />
      <SettingsMobileModal opened={themeOpened} onClose={closeThemeModal} />
      <ProfileModal opened={profileOpened} onClose={closeProfile} />
      <BillingModal opened={billingOpened} onClose={closeBilling} />
      <NotificationsModal opened={notificationsOpened} onClose={closeNotifications} />
    </>
  );
};

export default HeaderMobile;
